var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('el-button',{on:{"click":_vm.saveAsExcel}},[_vm._v("导出excel")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }